<main class="container" *ngIf="information_ads?.strTitle">

    <!-- اطلاعات آگهی -->

    <section class="main-container row w-full gx-2 p-2">

        <!-- اطلاعات سمت راست -->

        <div class="col-12 col-md-6 p-2">

            <div  class="w-100 h-100 p-2">

                <!-- عنوان آگهی -->

                <h1 class="fw-bold mb-2"> {{ information_ads.strTitle }} </h1>

                <!-- کد آگهی -->

                <p class="code"> کد آگهی : {{information_ads.iTaxilon_Advertisement | faNum }}  </p>

                <!-- محل آگهی -->

                <span class="ads-time text-muted"> {{ information_ads.strPublishTime | faNum }} <span *ngIf="information_ads.strPublishCity"> {{ 'در ' + information_ads.strPublishCity }} </span> </span>

                <!-- گزارش کلاهبرداری -->

                <div class="ads-warning mt-3 mb-2 d-flex justify-content-start align-items-center pointer" (click)="goTo_Support()">

                    <div class="d-flex align-items-center ">

                        <span class="d-flex material-symbols-outlined">

                            <mat-icon>warning</mat-icon>

                        </span>

                        <span class="mx-2"> گزارش کلاهبرداری و رفتار مشکوک </span>

                    </div>

                    <span class="d-flex material-symbols-outlined mr-4">

                        <mat-icon class="mat-18  text-muted">chevron_left</mat-icon>

                    </span>

                </div>

                <!-- مسئولیت تاکسی لون -->

                <div class="ads-warning my-2 w-100 d-flex justify-content-start align-items-center  ">

                    <div class="d-flex align-items-center ">

                        <span style="font-size: 12px;line-height: 22px;" class="mx-2">

                            تا زمانی که از صحت قرارداد، خودرو و یا خدمات راننده اطمینان کامل ندارید، وجهی پرداخت نکنید. تاکسی لون در قبال صحت مشخصات آگهی مسئولیتی ندارد.

                        </span>

                    </div>

                </div>

                <!-- دکمه شماره تماس -->

                <div class="ads-operation w-100 d-flex justify-content-between p-2">

                    <div class="buttons-container d-flex">

                        <div class="ads-call">

                            <button class="btn btn-call central px-4 pointer" (click)="show_Warning_Before_Call()" [disabled]="information_ads?.strMobile">

                                <mat-icon>call</mat-icon>

                                <span class="mx-2"> تماس </span>

                            </button>


                        </div>

                    </div>

                    <div class="ads-share-bookmark d-flex align-items-center justify-content-end w-25">

                        <span class="d-flex material-symbols-outlined" (click)="shareVia()">

                            <mat-icon class="mat-18 text-muted pointer">share</mat-icon>

                        </span>


                    </div>

                </div>

                <!-- اطلاعات آگهی گذار -->

                <div [@slideInOut]="information_ads?.strMobile ? 'open' : 'closed'" class="ads-address-number-show w-100 p-2 mt-2">

                    <div class="d-flex justify-content-between mb-4">

                        <span> شماره موبایل </span>

                        <div class="d-flex align-items-center pointer" (click)="callWith_advertiser()">

                            <span class="mx-2"> {{ information_ads?.strMobile | faNum }} </span>

                            <span class="d-flex material-symbols-outlined">

                                <mat-icon class="mat-18 text-muted">phone_in_talk</mat-icon>

                            </span>

                        </div>

                    </div>

                    <div style="background-color: #F0FAFF;" class="rounded-sm p-3 ">

                        <p class="fw-bold"> هشدار </p>

                        <span class="text-muted"> لطفاً پیش از انجام معامله و هر نوع پرداخت وجه، از صحت خودرو یا خدمات ارائه‌شده، به‌صورت حضوری اطمینان حاصل نمایید. </span>

                    </div>

                </div>

                <!-- اطلاعات عمودی -->

                <div class="ads-vertical p-4">

                    <div *ngFor="let item of information_ads.lstHorizontalInfo;let i = index;" [ngClass]=" true ? 'ads-info-' + (i+1) : '' " class="text-center col-4">

                        <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"> {{ item.strTitle || ' ' }} </span>

                        <h2 class="mb-0" style="line-height: initial!important;">

                            <span [innerHTML]="getSafeHtml(item.strValue)" class="text-dark fw-bold">
                            
                                {{ (item.strValue | faNum) || ' '}}
                            
                            </span>


                        </h2>

                    </div>

                </div>

                <!-- اطلاعات افقی -->

                <ng-container class="ads-horizontal" *ngFor="let item of information_ads.lstverticalInfo;let i = index;">

                    <div class="ads-horizontal w-100 d-flex justify-content-between mt-2 p-2">

                        <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"> {{ item.strTitle || ' ' }} </span>

                        <span [innerHTML]="getSafeHtml(item.strValue)" class="text-dark fw-bold"> {{( item.strValue | faNum ) || ''}} </span>

                    </div>

                    <hr class="ads-divider m-0 w-100">

                </ng-container>

                <!-- توضیحات آگهی -->

                <div *ngIf="information_ads.strDetail" class="ads-description w-100 mt-3 p-2">

                    <p> توضیحات </p>

                    <h2 class="mb-0" style="font-weight: 400;">

                        <span [innerText]="(information_ads.strDetail | faNum )"></span>

                    </h2>

                </div>

            </div>

        </div>

        <!-- اطلاعات سمت چپ -->

        <div class="col-12 col-md-6 h-100 p-2">

            <div class="w-100 h-100 p-2">
                
                <div class="ads-images-container h-65">
                    
                    <!-- عکس اصلی -->

                    <div class="ads-images-preview h-75">

                        <div class="position-relative w-full h-100 rounded">

                            <img class="w-100 h-100 rounded" [src]="information_ads?.list_Gallery?.[0]?.strImage ? 'data:image/jpeg;base64,' + information_ads.list_Gallery[0].strImage : '../../../assets/imgs/preview__thumbnail.png'" [alt]="information_ads?.strTitle || 'Image preview'">

                            <span *ngIf="information_ads?.list_Gallery.length > 0" class="position-absolute pointer" (click)="openGallery(information_ads?.list_Gallery?.[0],0)"> 
                                
                                <mat-icon> fullscreen </mat-icon>

                                {{ information_ads?.list_Gallery.length | faNum }}
                            
                            </span>

                        </div>

                    </div>

                    <!-- بقیه تصاویر -->

                    <div *ngIf="information_ads?.list_Gallery.length > 1" class="ads-images-all w-full row dil gx-2 pt-1 h-25">

                        <div *ngFor="let item of list_AdsImagesShown;let i = index" class="ads-image col-md-4 col-6 p-2">

                            <div class="w-full h-100 rounded position-relative" (click)="openGallery(item,i)">

                                <ng-container *ngIf=" i == 0">

                                    <div *ngIf="list_AdsImagesCounter > 0" class="pic-counter pointer">

                                        +{{ list_AdsImagesCounter | faNum }}

                                    </div>

                                </ng-container>

                                <img class="w-100 h-100 rounded" src="{{'data:image/jpeg;base64,' + item.strImage}}" [alt]="information_ads?.strTitle">

                            </div>

                        </div>

                    </div>

                    <!-- یادداشت آگهی -->

                    <div class="ads-note my-2 w-full">

                        <textarea id="textArea_" [ngModel]="information_ads?.strUserComment" cols="10" rows="4" class="form-control mb-1" placeholder="یادداشت شما ..."></textarea>

                        <small class="text-muted">

                            یادداشت های اختصاصی شما مربوط به آگهی که پس از حذف آگهی حذف خواهند شد.

                        </small>

                    </div>

                </div>

            </div>

        </div>

    </section>

    <!-- لینک های مرتبط -->

    <section *ngIf="information_ads?.lst_Links?.length" class="container row gx-0 gy-3 pb-3 mt-2 px-3 border-top border-1 ">

        <div class="central sec_title mt-5 my-3">

            <i class="fa fa-link" aria-hidden="true"></i>

            <h2 class="mb-0"> لینک های مرتبط </h2>

        </div>

        <ng-container *ngFor="let item of information_ads?.lst_Links">

            <a [href]="item.strURL" target="_blank" [title]="item.strTitle">
            
                {{ item.strTitle | faNum }} 
            
            </a>

        </ng-container>

    </section>        

    <!-- گالری تصاویر -->

    <div class="modal fade dir" id="galleryComp_Modal" role="dialog" style="z-index: 1000!important;">

        <div class="modal-dialog modal-fullscreen modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header d-flex justify-content-between">

                    <h3 class="modal-title mb-0"> گالری تصاویر </h3>

                    <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal"></button>

                </div>

                <div class="modal-body">

                    <ng-container *ngIf="isAlbum">

                        <custom-gallery 
                        
                            [albumIndex]="albumIndex"

                            [lst_Album]="lst_Album"

                            [isDownloadAble]="false"
                            
                            [strKey_list]="'strImage'">
                    
                        </custom-gallery>
                        
                    </ng-container>

                </div>

            </div>

        </div>

    </div>

</main>